import type { SerializedEditorState } from 'lexical';
import { z } from 'zod';

export const flowItemFormSchema = z.object({
	idn: z.string().min(1),
	mentions: z.array(
		z.object({
			item_idn: z.string(),
			type: z.string()
		})
	),
	title: z.any(),
	body: z.any(),
	is_from_library: z.boolean(),
	origin_idn: z.string().optional()
});

export type FlowItemFormValues = Omit<
	z.infer<typeof flowItemFormSchema>,
	'title' | 'body'
> & {
	title: SerializedEditorState;
	body: SerializedEditorState;
};
